import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=2b02e269&scoped=true&"
import script from "./MainOrder.vue?vue&type=script&lang=ts&"
export * from "./MainOrder.vue?vue&type=script&lang=ts&"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=2b02e269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02e269",
  null
  
)

export default component.exports